// extracted by mini-css-extract-plugin
export default {"homeContainer":"Home_homeContainer__H9L9L","main":"Home_main__dT4IZ"};